import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const create_member_state_op = function (state, user, next_state) {
  const current = state.timer_map.get(user._id);
  const next = {
    state: next_state,
    time: new Date()
  };
  return {
    previous: current,
    next: next
  };
}

export default new Vuex.Store({
  state: {
    user: null,
    company: null,
    crew: null,
    task: null,
    timer_map: null,
    companies: [],
    crews: [],
    member_bus: new Vue(),
    language: "en"
  },
  getters: {
    active_timers: (state) => {
      if (!state.crew) return false;
      for (const m of state.crew.members) {
        const ms = state.timer_map.get(m._id);
        if (ms && ms.state != 'absent') return true;
      }
      return false;
    },
    member_state: (state) => (id) => {
      const ms = state.timer_map.get(id);
      return ms || {
        state: "absent"
      };
    }
  },
  methods: {},
  actions: {
    change_state({
      commit,
      state
    }, {
      user,
      next_state
    }) {
      const result = create_member_state_op(state, user, next_state);
      commit("member_state", {
        user: user,
        next: result.next
      });
      state.member_bus.$emit('member_state_change', {
        user: user,
        previous: result.previous,
        next: result.next
      });
    },
  },
  mutations: {
    load(state, stored) {
      state.user = stored.user;
      state.companies = stored.companies;
      state.company = stored.company;
      state.crew = stored.crew;
      state.task = stored.task;
      state.timer_map = new Map();
      state.language = stored.language;
    },
    language(state, language) {
      state.language = language;
    },
    login(state, user) {
      if (!user) {
        state.user = null;
        state.companies = [];
        state.company = null;
        state.crew = null;
        state.task = null;
        state.timer_map = new Map();
        return;
      }
      state.user = user;
      state.companies = user.companies.filter(c => c.crews && c.crews.length > 0);

      if (state.companies.length > 0) {
        state.company = state.companies[0];
      } else {
        return;
      }
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
      } else {
        return;
      }

      state.task = state.crew.task;

      state.timer_map = new Map();
      // This should be set by caller...
      state.language = user.langauge;
    },
    company(state, company) {
      state.company = company;
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
      } else {
        return;
      }

      state.task = state.crew.task;

      state.timer_map = new Map();
    },
    restore_member_state(state, op) {
      state.timer_map.set(op.user._id, op.state);
      state.timer_map = new Map(state.timer_map);
    },
    member_state(state, op) {
      state.timer_map.set(op.user._id, op.next);
      state.timer_map = new Map(state.timer_map);
    }
  },
  modules: {}
});